export const COMPARISON_CONSTANTS_NETWORKING = {
  title: "Modern Connectivity: Traditional vs OneMind Networking",
  desc: "Legacy LAN/WAN models are rigid, costly to scale, and vulnerable to downtime. OneMind’s managed wired and wireless networking unlocks secure, flexible performance from edge to cloud.",
  items: [
    {
      title: "The Old Way",
      subTitle: "Traditional Wired & Wireless Networks",
      points: [
        "Fragmented LAN/WAN systems with poor scalability",
        "Manual setup and patching across multiple hardware platforms",
        "No centralized visibility or unified policy control",
        "Weak Wi-Fi performance in high-density or mobile environments",
        "Difficult to secure remote and BYOD access",
        "Reactive troubleshooting with no performance insights",
      ],
    },
    {
      title: "The New Way",
      subTitle: "OneMind Wired & Wireless Networking",
      points: [
        "Scalable LAN and enterprise-grade Wi-Fi with end-to-end coverage",
        "Centralized design, deployment, and management from the cloud",
        "Unified policies across wired, wireless, and remote access points",
        "Optimized roaming and mesh Wi-Fi for seamless mobile connectivity",
        "Integrated network access control (NAC) and identity-based security",
        "Real-time monitoring, analytics, and performance optimization",
      ],
    },
  ],
};
